import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "quiz-html-editor-container"
};
const _hoisted_2 = {
  key: 0,
  class: "quiz-html-editor-title"
};
const _hoisted_3 = {
  key: 1,
  class: "quiz-html-editor-close-btn"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_w_tiny_mce = _resolveComponent("w-tiny-mce");
  const _component_w_link = _resolveComponent("w-link");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.editorTitle ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.editorTitle), 1)) : _createCommentVNode("", true), _createVNode(_component_w_tiny_mce, {
    editorId: _ctx.editorId,
    customConfig: _ctx.editorConfig,
    text: _ctx.content,
    "display-editor-buttons": false,
    onBlur: _ctx.onBlur
  }, null, 8, ["editorId", "customConfig", "text", "onBlur"]), _ctx.displayCloseBtn ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_w_link, {
    onClick: _ctx.onCloseBtnClick,
    type: "primary",
    class: "linkPrimary"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.closeBtnLabel), 1)]),
    _: 1
  }, 8, ["onClick"])])) : _createCommentVNode("", true)]);
}